<template>
  <div class="container py-4">
    <div class="row justify-content-center">
      <div class="col-12 col-md-10 col-lg-8">
        <div class="card">
          <div class="card-header p-0 overflow-hidden">
            <div class="header-container d-flex justify-content-center align-items-center py-3 logo-header">
              <img :src="branding.loginLogo" :alt="branding.name + ' Logo'" class="logo-image" />
            </div>
          </div>
          <div class="card-body">
            <!-- Íslenska -->
            <h4>Persónuverndarstefna — {{ branding.name }}</h4>
            <p class="text-muted">Síðast uppfært: 31. ágúst 2026</p>

            <h6>1. Ábyrgðaraðili</h6>
            <p>
              {{ branding.name }} er þjónusta rekin af Rún Solutions ehf. Þegar
              vinnuveitandi þinn eða fyrirtæki notar {{ branding.name }} er það
              fyrirtæki ábyrgðaraðili gagna sinna og Rún Solutions ehf. vinnsluaðili.
            </p>

            <h6>2. Hvaða gögn við söfnum</h6>
            <ul>
              <li>Reikningsupplýsingar: nafn, netfang, símanúmer og lykilorð (dulkóðað).</li>
              <li>Notkunargögn: skráningar á verkfærum, frátektir, tímaskráningar (innstimplun/útstimplun) og verkefnatengingar.</li>
              <li>Staðsetningargögn: staðsetning verkfæra og tækja fyrirtækisins, m.a. frá GPS-sendum og þegar QR-kóði er skannaður.</li>
              <li>Tæknileg gögn: vafrakökur fyrir innskráningu og tilkynningaáskriftir ef þú kveikir á tilkynningum.</li>
            </ul>
            <p>
              Myndavél símans er eingöngu notuð til að lesa QR-kóða; myndefni er
              unnið í vafranum og er hvorki vistað né sent á netþjóna okkar.
            </p>

            <h6>3. Tilgangur vinnslu</h6>
            <p>
              Gögnin eru notuð til að veita þjónustuna: halda utan um verkfæri,
              frátektir, tímaskráningar og tengingar við bókhaldskerfi sem
              fyrirtækið þitt hefur valið. Við seljum aldrei persónuupplýsingar.
            </p>

            <h6>4. Miðlun</h6>
            <p>
              Gögnum er aðeins miðlað til þriðja aðila að vali fyrirtækisins þíns
              (t.d. bókhalds-/launakerfi á borð við DK, Tímon eða Business Central)
              og til hýsingaraðila okkar (Amazon Web Services, gagnaver í Evrópu).
            </p>

            <h6>5. Varðveisla og réttindi þín</h6>
            <p>
              Gögn eru varðveitt á meðan fyrirtækið þitt er með virkan aðgang.
              Þú átt rétt á aðgangi að, leiðréttingu á og eyðingu þinna gagna.
              Hafðu samband við stjórnanda fyrirtækisins þíns eða okkur beint:
              <a href="mailto:runsolutions@runsolutions.is">runsolutions@runsolutions.is</a>.
            </p>

            <hr class="my-4" />

            <!-- English -->
            <h4>Privacy Policy — {{ branding.name }}</h4>
            <p class="text-muted">Last updated: 31 August 2026</p>

            <h6>1. Who we are</h6>
            <p>
              {{ branding.name }} is a service operated by Rún Solutions ehf.,
              Iceland. When your employer or company uses {{ branding.name }},
              that company is the data controller and Rún Solutions ehf. acts
              as the data processor.
            </p>

            <h6>2. What we collect</h6>
            <ul>
              <li>Account data: name, email address, phone number and an encrypted password.</li>
              <li>Usage data: tool registrations, reservations, time registration (clock in/out) and project assignments.</li>
              <li>Location data: locations of your company's tools and vehicles, including GPS tracker readings and the location of QR-code scans.</li>
              <li>Technical data: cookies used for sign-in, and push notification subscriptions if you enable notifications.</li>
            </ul>
            <p>
              The device camera is used only to read QR codes; camera frames are
              processed in your browser and are never stored or sent to our servers.
            </p>

            <h6>3. Why we process it</h6>
            <p>
              We process this data solely to provide the service: managing tools,
              reservations, time registration and integrations with the ERP
              systems your company has configured. We never sell personal data.
            </p>

            <h6>4. Sharing</h6>
            <p>
              Data is shared only with third parties chosen by your company
              (e.g. ERP/payroll systems such as DK, Tímon or Business Central)
              and with our hosting provider (Amazon Web Services, EU data centers).
            </p>

            <h6>5. Retention and your rights</h6>
            <p>
              Data is retained while your company has an active subscription.
              You have the right to access, correct and delete your personal
              data. Contact your company administrator, or reach us directly at
              <a href="mailto:runsolutions@runsolutions.is">runsolutions@runsolutions.is</a>.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import branding from "@/branding";

export default {
  name: "PrivacyPolicy",
  data() {
    return {
      branding,
    };
  },
};
</script>

<style scoped>
.logo-header {
  background-color: #27293d;
}
.logo-image {
  max-height: 60px;
  max-width: 80%;
  object-fit: contain;
}
</style>
